import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const editPassword = ({current_password, password, password_confirmation}) => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.PUT,
    path: `/api/v1/users`,
    body: {
      user: {
        current_password,
        password,
        password_confirmation,
      },
    },
  });
};

export default editPassword;
